module.exports = __webpack_public_path__ + "static/media/img122_R.b1998dc7.jpg";